"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gtagEvent = exports.gtag = exports.GtagEvents = void 0;
var GtagEvents;
(function (GtagEvents) {
    GtagEvents["SIGNUP"] = "signup";
    GtagEvents["DEPOSIT_SUCCESS_INIT"] = "deposit-success-init";
    GtagEvents["DEPOSIT_FAILED_INIT"] = "deposit-failed-init";
})(GtagEvents = exports.GtagEvents || (exports.GtagEvents = {}));
var gtag = function () {
    var _a, _b;
    var arg = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        arg[_i] = arguments[_i];
    }
    // @ts-ignore
    if (window !== 'undefined' && (window === null || window === void 0 ? void 0 : window.dataLayer)) {
        // @ts-ignore
        (_b = (_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.push) === null || _b === void 0 ? void 0 : _b.call(_a, arguments);
    }
};
exports.gtag = gtag;
var gtagEvent = function (eventName, additionalData) {
    if (!additionalData) {
        (0, exports.gtag)('event', eventName);
    }
    else {
        (0, exports.gtag)('event', eventName, additionalData);
    }
};
exports.gtagEvent = gtagEvent;
